import React from 'react';
import { ParagraphMedium } from '../../../../../core/components';
import { Item, MultiToggle } from '../../../../../core/components/toggle';
import simulatorConfig from '../../../constants/simulator-config-constants';
import { CoilsProps, ExperimentConfiguration } from '../../../models';
import { ModalSectionContainer } from '../modal-section-container';

export interface CoilSectionProps {
  config: ExperimentConfiguration[];
  setCoilType: (action: string, value: string, configurationName: string) => void;
  additionalCoils: CoilsProps[];
}

export const CoilSection: React.FC<CoilSectionProps> = (props: CoilSectionProps): React.ReactElement => {
  const { config, setCoilType, additionalCoils } = props;

  const onAdvancedCoilSelectHandler = (coil: string) => {
    setCoilType('true', coil, simulatorConfig.COIL);
  };

  const advancedCoilType = config?.find((c: ExperimentConfiguration) => c.id === 29)?.selectedValue;

  const ADVANCED_COIL_OPTIONS: Item<string>[] = additionalCoils.map((m: CoilsProps) => {
    return {
      id: m.unique_name,
      label: m.shown_name,
    };
  });

  return (
    <ModalSectionContainer title="Coil">
      <ParagraphMedium>Select which settings you wish to use</ParagraphMedium>
      <MultiToggle
        items={ADVANCED_COIL_OPTIONS}
        onSelect={(key) => onAdvancedCoilSelectHandler(key as string)}
        selectedItemKey={advancedCoilType}
      />
    </ModalSectionContainer>
  );
};
